// src/pages/Appli/AppliAdmin/VisitorCenter/components/VisitorBreakdownCards.jsx

import React from "react";

import {
  FiCompass,
  FiMonitor,
  FiNavigation,
} from "react-icons/fi";

import {
  EmptyState,
  SectionCard,
} from "../ui/VisitorCenterUi";

import {
  formatCompactNumber,
  safeNumber,
} from "../utils/visitorFormatters";

const DEVICE_LABELS = {
  desktop: "Ordinateur",
  mobile: "Mobile",
  tablet: "Tablette",
  unknown: "Inconnu",
};

function BreakdownList({
  rows,
  getLabel,
  getValue,
}) {
  const maxValue = Math.max(
    ...rows.map((row) =>
      safeNumber(
        getValue(row),
      ),
    ),
    1,
  );

  return (
    <div className="space-y-4 p-5 lg:p-6">
      {rows.map((row, index) => {
        const value =
          safeNumber(
            getValue(row),
          );

        const progress =
          Math.max(
            5,
            Math.round(
              (
                value /
                maxValue
              ) * 100,
            ),
          );

        return (
          <div
            key={index}
          >
            <div className="flex items-center justify-between gap-4">
              <div className="min-w-0 truncate text-sm font-bold text-slate-700">
                {getLabel(row)}
              </div>

              <div className="shrink-0 text-sm font-extrabold text-[#123B57]">
                {formatCompactNumber(
                  value,
                )}
              </div>
            </div>

            <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-100">
              <div
                className="h-full rounded-full bg-gradient-to-r from-[#123B57] to-[#2EA7E0]"
                style={{
                  width:
                    `${progress}%`,
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function VisitorBreakdownCards({
  sources = [],
  devices = [],
  browsers = [],
}) {
  return (
    <div className="grid gap-6 xl:grid-cols-3">
      <SectionCard
        title="Origine du trafic"
        subtitle="Canaux ayant amené les visiteurs."
      >
        {sources.length ? (
          <BreakdownList
            rows={sources}
            getLabel={(row) => {
              if (
                !row.medium ||
                row.medium === "none"
              ) {
                return row.source;
              }

              return `${row.source} · ${row.medium}`;
            }}
            getValue={(row) =>
              row.sessions
            }
          />
        ) : (
          <EmptyState
            icon={FiNavigation}
            title="Aucune source"
            description="Les sources de trafic apparaîtront ici."
          />
        )}
      </SectionCard>

      <SectionCard
        title="Appareils"
        subtitle="Supports utilisés pour visiter le site."
      >
        {devices.length ? (
          <BreakdownList
            rows={devices}
            getLabel={(row) =>
              DEVICE_LABELS[
                row.device_type
              ] ||
              row.device_type ||
              "Inconnu"
            }
            getValue={(row) =>
              row.sessions
            }
          />
        ) : (
          <EmptyState
            icon={FiMonitor}
            title="Aucun appareil"
            description="La répartition des appareils apparaîtra ici."
          />
        )}
      </SectionCard>

      <SectionCard
        title="Navigateurs"
        subtitle="Navigateurs les plus utilisés."
      >
        {browsers.length ? (
          <BreakdownList
            rows={browsers}
            getLabel={(row) =>
              row.browser_name ||
              "Inconnu"
            }
            getValue={(row) =>
              row.sessions
            }
          />
        ) : (
          <EmptyState
            icon={FiCompass}
            title="Aucun navigateur"
            description="La répartition des navigateurs apparaîtra ici."
          />
        )}
      </SectionCard>
    </div>
  );
}